<div class="containerPpal">
    <div class="comp1">
        <app-menu></app-menu>
    </div>
    <div class="comp2">
        <router-outlet></router-outlet>
    </div>
</div>